import React from "react";
import {OrdersUIProvider} from "../OrdersUIContext";
import OrderEdit from "./OrderEdit";

export default function OrderEditIndex(
    {
        match: {
            params: {id},
        },
    }
) {
    return (
        <OrdersUIProvider>
            <OrderEdit id={id}/>
        </OrdersUIProvider>
    )
}